module.exports = __webpack_public_path__ + "static/media/sensori.23058f78.jpg";